export function repeat(text, count) {
    var result = "";
    if (typeof text.repeat === "function") {
        result = text.repeat(count);
    }
    else {
        if (count > 0) {
            while (count > 1) {
                if (count & 1) {
                    result += text;
                }
                count >>= 1;
                text += text;
            }
            result = result + text;
        }
    }
    return result;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/firebase-key/dist/text-repeat.js
// module id = 1155
// module chunks = 0